module.exports = __webpack_public_path__ + "static/img/1.43984d11.png";